import ManageVoucherModule from '@/modules/manage-voucher';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/dashboard/product/manage-voucher')({
  component: ManageVoucherPage,
});

function ManageVoucherPage() {
  return <ManageVoucherModule />;
}
